import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import ReactDOM from 'react-dom'

// import styles from './styles.css'
import Icon from '_components/icon'

class ReactSwipe extends PureComponent {
  static propTypes = {
    children: PropTypes.array.isRequired,
  }

  state = {
    activeChildIndex: 0,
  }

  componentDidMount() {
    const { children } = this.props
  }

  next = () => {
    this.container.classList.remove('fadeIn')
    this.container.classList.add('fadeOut')
    setTimeout(() => {
      this.setState({
        activeChildIndex: 1,
      })
      this.container.classList.remove('fadeOut')
      this.container.classList.add('fadeIn')
    }, 1000)
  }

  prev = () => {
    this.container.classList.remove('fadeIn')
    this.container.classList.add('fadeOut')
    setTimeout(() => {
      this.setState({
        activeChildIndex: 0,
      })
      this.container.classList.remove('fadeOut')
      this.container.classList.add('fadeIn')
    }, 1000)
  }

  render() {
    const { children } = this.props
    const { activeChildIndex } = this.state

    return (
      <div
        ref={el => (this.container = el)}
        className="animated fadeIn"
        style={{
          display: 'flex',
          flex: 1,
          animationDuration: '1s',
          position: 'relative',
        }}
      >
        {children[activeChildIndex]}
      </div>
    )
  }
}

export default ReactSwipe



// WEBPACK FOOTER //
// ./src/components/categoryTabs/categoryTabBodySwipe/reactSwipe/index.js